//
//
//
//
//
//
//

import i18n from "@/utils/i18n";
import eventMixin from "@/components/form-designer/setting-panel/property-editor/event-handler/eventMixin";
export default {
  name: "onMounted-editor",
  mixins: [i18n, eventMixin],
  props: {
    designer: Object,
    selectedWidget: Object,
    optionModel: Object
  },
  data: function data() {
    return {
      eventParams: []
    };
  }
};